enum RescheduleTypes {
  LaterDate = 'later_date',
  EarlierDate = 'earlier_date',
  Within48Hours = 'within_48_hrs',
}

export { RescheduleTypes }
